import { useTranslation } from 'react-i18next';
import './GreenAlert.scss';

export default function GreenAlert() {
  const { t } = useTranslation();
  return (
    <div
      className='GreenAlert text-white pt-2 pb-3 px-3 mb-3'
      data-testid='green-alert'
    >
      <div className='fw-800' data-testid='green-alert-title'>
        {t("You don't have any ongoing tasks")}
      </div>
      <div data-testid='green-alert-text'>
        {t('Once we need something from you, you would get an email')}
      </div>
    </div>
  );
}
